
  export default {
    props: {
      postIdx: {
        type: Number,
        default: 0
      },
      exploreData: {
        default: {}
      },
      attractionIdx: {
        type: Number,
        default: 0
      },
      attractions: {
        default: ''
      }

    },
    methods: {
      goToLink(type, slug, index, ind, attractions) {
        let postType = this.getPostType(type);

        if (attractions && attractions.length > 0) {
          let data = {
            postIndex: index,
            attractionIndex: ind,
            allAttractions: attractions
          }
          this.$emit('blogIdSent', slug)
          localStorage.setItem("plcData", JSON.stringify(data));
          // this.$router.push({
          //   path: "/places/" + slug,
          // });
        }

        this.$router.push({
          path: `/${postType}/${slug}`
        })
      },

      getPostType(type) {
        switch (type) {
          case 'activity':
            return 'activities';
          case 'blog':
            return 'blog';
          case 'event':
            return 'event';
          case 'hotel':
            return 'hotel';
          case 'restaurant':
            return 'restaurant';
          case 'package':
            return 'packages';
            // case 'stay':
            //   return 'stay';
          case 'place':
            return 'places';
          default:
            return 'places';
        }
      }
    }
  }
